import React from "react"
import { Modal, Button, Flex } from "antd"
import styles from "./index.module.css"
import PropTypes from "prop-types"
import WarningOutlinedWithBg from "ui/WarningOutlinedWithBg"
const { confirm } = Modal

export const DeleteConfirmation = ({
  visible,
  onCancel,
  onConfirm,
  title = "Delete Template",
  content = "Are you sure you want to delete this template? This action cannot be undone.",
  confirmText = "Delete",
  cancelText = "Cancel",
  loading = false
}) => {
  return (
    <Modal open={visible} onCancel={onCancel} footer={null} centered className={styles.deleteModal} width={400}>
      <div className={styles.modalContent}>
        <div className={styles.iconWrapper}>
          <WarningOutlinedWithBg />{" "}
        </div>
        <h3 className={styles.modalTitle}>{title}</h3>
        <p className={styles.modalText}>{content}</p>
        <Flex align="center" gap={10}>
          <Button onClick={onCancel} color="primary" variant="outlined" disabled={loading}>
            {cancelText}
          </Button>
          <Button color="primary" variant="solid" onClick={onConfirm} loading={loading}>
            {confirmText}
          </Button>
        </Flex>
      </div>
    </Modal>
  )
}

DeleteConfirmation.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  loading: PropTypes.bool
}

export default DeleteConfirmation
